import styled from "styled-components"

export const Blue = styled.span`
  color: ${({ theme: { colors } }) => colors.blue[100]};

  ::selection {
    background: ${({ theme }) => theme.colors.blue[5]};
  }
`
